import { KeycloakOptions } from 'keycloak-angular';

import { shouldAttachApiToken } from './api-request-policy';

export interface BrowserKeycloakConfiguration {
  issuer: string;
  realm: string;
  clientId: string;
}

export function createKeycloakOptions(
  keycloak: BrowserKeycloakConfiguration,
  apiEndpoint: string,
  browserOrigin: string
): KeycloakOptions {
  const silentCheckSsoRedirectUri = new URL(
    '/assets/silent-check-sso.html',
    browserOrigin
  ).toString();

  return {
    config: {
      url: keycloak.issuer,
      realm: keycloak.realm,
      clientId: keycloak.clientId,
    },
    initOptions: {
      onLoad: 'check-sso',
      pkceMethod: 'S256',
      silentCheckSsoRedirectUri,
    },
    loadUserProfileAtStartUp: true,
    shouldAddToken: (request) =>
      shouldAttachApiToken(request.url, apiEndpoint, browserOrigin),
  };
}
